<template>
    <v-layout>
        <v-main>
            <v-container>
                <v-card class="text-h6 justify-center" style="padding: 1em !important">
                    <h2>Aktuelles:</h2><br />
                    <h3>03. Oktober 2023 - Neue Kittenbilder - Woche 18!</h3>
                    Wir haben wieder neue Fotos von den Kitten für euch hochgeladen! <u><router-link to="wuerfe">Zu den Fotos!</router-link></u>
                    <h3>14. August 2023 - Endlich neue Bilder - Tag 78!</h3>
                    Unsere Kurzen haben sich nach laaanger Spielzeit wieder getraut mal wieder FAST ruhig vor die Kamera zu setzen! <u><router-link to="wuerfe">Zu den Fotos!</router-link></u>
                    <h3>09. Juli 2023 - Neue Kittenbilder - Tag 42!</h3>
                    Es gibt wieder neue Fotos von den Kurzen! <u><router-link to="wuerfe">Zu den Fotos!</router-link></u>
                    <h3>27. Juni 2023 - Neue Kittenbilder - Tag 30!</h3>
                    In einer guten Woche tut sich viel bei den Fellpopos! Neue Bilder sind online, wie immer unter <u><router-link to="wuerfe">Würfen</router-link></u> zu finden!
                    <h3>18. Juni 2023 - Neue Kittenbilder</h3>
                    Die Kleinen wachsen so schnell! Die Bilder von heute findet ihr bei den <u><router-link to="wuerfe">Würfen</router-link></u>!
                    
                    <h3>07. Juni 2023 - Wir haben Kitten!</h3>
                    Unser A-Wurf ist am 28.05.23 gelandet.<br />
                    Alles ist super gelaufen. Sirona ist eine absolut liebevolle Mama, besser hätte es nicht laufen können
                    😊<br />
                    Aktuelle Bilder der Pummelbärchen findet ihr unter <u><router-link to="wuerfe">Würfe</router-link></u>
                </v-card>
            </v-container>
        </v-main>
    </v-layout>
</template>

<!--
    TODO: Sidebar mit Links zu "Artikeln" und Artikel nachladen
-->
